module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qhand2-c2903c9125eda694d15be642b893d5aa.jpg";